import * as types from './ActionTypes';
import { create } from 'axios';
import { addToast } from './toast.action';
import { getUsers } from './users.action';

const ajax = create({
  contentType: 'application/json',
  baseURL: process.env.REACT_APP_CORE_USER_API_URL
});

ajax.defaults.withCredentials = true;

export const sendRegistrationEmail = editUser => dispatch => {
  dispatch({ type: types.REGISTRATION_EMAIL_PENDING });

  ajax.post(`/persons/invite/${editUser.externalKey}`)
    .then(() => {
      dispatch({ type: types.REGISTRATION_EMAIL_SUCCESS });
      dispatch(
        addToast({
          autohide: false,
          toasts: [
            {
              action: 'dismiss',
              text: `User ${editUser.displayName} sent registration email`
            }
          ]
        })
      );
    })
    .then(() => dispatch(getUsers()))
    .catch(error => {
      dispatch({
        type: types.REGISTRATION_EMAIL_REJECTED,
        payload: error
      });
      dispatch({
        type: types.SET_ERROR_DIALOG,
        payload: {
          error,
          visible: true
        }
      });
    });
};



// WEBPACK FOOTER //
// ./src/actions/registrationEmail.action.js